import { useEffect, useState } from 'react';

interface Props {
  sendToSignMutation: (variables: { businessKey: string; data: any }, options?: { onSuccess?: (response: any) => void }) => void;
  dataToSignMutation?: any;
  businessKey?: string;
  close: (state: boolean) => void;
}
const useOtpConfirmation = (props: Props) => {
  const { sendToSignMutation, dataToSignMutation, businessKey, close } = props;

  const [successModal, setSuccessModal] = useState(false);
  const [unSuccessModal, setUnSuccessModal] = useState(false);
  const [otp, setOtp] = useState('');
  const [asanModal,setAsanModal] = useState(false);
  const [dataForAsan, setDataForAsan] = useState<{
    business_key?: string;
    path_url?: string;
    timer?: number;
    verification_code?: string;
  }>({});


  useEffect(() => {
    console.log('dataToSignMutation', dataToSignMutation);
    
    if (dataToSignMutation?.form_id === 'success_action') {
      setSuccessModal(true);
      close(false);
    }
  }, [dataToSignMutation]);

  const handleSendOtp = (otpCode: string) => {
    sendToSignMutation({ businessKey, data: { otp: otpCode }}, {
      onSuccess: (res) => {
        if (res.form_id === 'asan_wait_popup') {
          close(false);
          setDataForAsan(res)
          setAsanModal(true);

        }
      },
    });
  };

  const handleResendOtp = () => {
    sendToSignMutation({ businessKey, data: { action: 'renew_otp' } });
  };

  const handleCancelOtp = () => {
    sendToSignMutation({ businessKey, data: { action: 'cancel' } });
  };

  return {
    handleSendOtp,
    handleResendOtp,
    handleCancelOtp,
    successModal,
    setUnSuccessModal,
    setSuccessModal,
    unSuccessModal,
    otp,
    setOtp,
    asanModal,
    setAsanModal,
    dataForAsan
  };
};

export default useOtpConfirmation;
